'use client';

import type { ReactNode } from 'react';
import type { CardRenderContext } from '../../tool-config-types';
import {
  AskUserAnswerCardView,
  readAskUserAnswer,
  readAskUserPrompt,
} from './ask-user-answer-card-view';

export function renderAskUserAnswerCard(ctx: CardRenderContext): ReactNode {
  if (ctx.toolCallData.status !== 'completed') {
    return null;
  }

  const prompt = readAskUserPrompt(ctx.toolCallData.input);
  const { answer, skipped, answerMentions, answerSegments } = readAskUserAnswer(
    ctx.toolCallData.output,
  );

  return (
    <AskUserAnswerCardView
      prompt={prompt}
      answer={answer}
      skipped={skipped}
      answerMentions={answerMentions}
      answerSegments={answerSegments}
      onChangeAnswer={
        ctx.onEditAskUserAnswer
          ? () =>
              ctx.onEditAskUserAnswer?.({
                toolCallId: ctx.toolCallData.toolCallId,
                toolCallPartId: ctx.toolCallData.id,
              })
          : undefined
      }
    />
  );
}
